import React, { useEffect } from "react";
import Nav from "./components/Nav";
import About from "./components/About";
import WhyUS from "./components/WhyUS";
import Footer from "./components/Footer";
import FloatingIcons from "./components/FloatingIcons";

const AboutUS = () => {
  return (
    <>
      <title> من نحن | مؤسسة محمد إبراهيم أبو عدبه للمحاماة والأستشارات القانونية</title>
      <Nav />
      <FloatingIcons />
      <div style={{ paddingTop: "150px" }}>
        <About />
      </div>
      <WhyUS />
      <Footer />
    </>
  );
};

export default AboutUS;
